<template>
  <div class="plan">
    <div class="topUl">
      <ul>
        <li>保障项目</li>
        <li>保障金额</li>
        <li>保障范围</li>
      </ul>
    </div>
    <div class="bottomUl">
      <ul>
        <li>{{ data.safeguardItems }}</li>
        <li>{{ data.amountInsured }}</li>
        <li>
          <p>{{ data.scopeApplication }}</p>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  props: ["data"],
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
  mounted() {},
};
</script>

<style lang='scss' scoped >
.plan {
  //   margin-top: 30px;
  width: 94%;
  margin: 0 auto;
  // height: 100%;
  box-sizing: border-box;
  .topUl {
    ul {
      border: 1px solid #e6e9e7;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      padding: 0 20px;
      li {
        height: 50px;
        line-height: 50px;
        text-align: left;
        display: inline-block;
        padding-left: 10px;
        &:nth-of-type(1) {
          width: 25%;
        }
        &:nth-of-type(2) {
          width: 25%;
        }
        &:nth-of-type(3) {
          width: 50%;
        }
      }
    }
  }
  .bottomUl {
    ul {
      border: 1px solid #e6e9e7;
      border-top: none;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      padding: 0 20px;
      li {
        padding: 20px;
        box-sizing: border-box;
        min-height: 50px;
        // line-height: 50px;
        text-align: left;
        display: inline-block;
        padding-left: 10px;
        &:nth-of-type(1) {
          width: 25%;
        }
        &:nth-of-type(2) {
          width: 25%;
        }
        &:nth-of-type(3) {
          width: 50%;
        }
      }
    }
  }
}
</style>
